// import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import DatePicker from "react-datepicker";
// import TableChartIcon from "@mui/icons-material/TableChart";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun } from "docx";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatus } from "../../../../../store/slices/statusSlice";
import { setPotentialFromDateRedux, setPotentialStatusRedux, setPotentialToDateRedux } from "../../../../../store/slices/filterSlice";
import { setFilteredNavData } from "../../../../../store/slices/LeadreportfilteredSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";
import { ChevronDown } from "lucide-react"
import { ChartColumnDecreasing } from "lucide-react"
import { TableOfContents } from "lucide-react"
// import { Download } from "lucide-react"
import { Calendar } from "lucide-react"
import { setDownloadReportTitle } from "../../../../../store/slices/pageSlice";
import DownloadReport from "../../../../../pages/lead/DownloadReport";
import { hasViewOrFullAccess } from "../../../../../utils/featureAccessUtils";

const fmtPctDisplay = (n) => {
    const x = Number(n) || 0;
    return x.toFixed(2).replace(/\.00$/, "");
};

const PotentialStatus = ({ currentEmployee, hasNoFeatureConfig, userLevel }) => {
    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
    const USAComma = CommaConvert();

    const sendDownlodTile = () => {
        dispatch(setDownloadReportTitle("PotentialStatusReport"));
    };

    const canShowGraphs = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "POTENTIAL STATUS GRAPHS");
    const canShowFilter = userLevel === "L0" || hasNoFeatureConfig || !currentEmployee || hasViewOrFullAccess(currentEmployee, "POTENTIAL STATUS FILTER");

    const [potentialStatusDownload, setPotentialStatusDownload] = useState([]);
    const StatusdropdownRef = useRef(null);
    const [showsourseDropdown, setshowsourceDropdown] = useState(false);
    const [filteredLeadReportsLead, setFilteredLeadReportsLead] = useState([]);
    const { filteredReports } = useSelector((state) => state.filteredData);
    const [showgraph, setShowgraph] = useState(true);

    const handleToggleTable = () => {
        setShowgraph(!showgraph);
    };
    useEffect(() => {
        if (Array.isArray(filteredReports)) {
            setFilteredLeadReportsLead(filteredReports);
        }
    }, [filteredReports]);
    // Handle clicks outside the dropdown to close it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                StatusdropdownRef.current &&
                !StatusdropdownRef.current.contains(event.target)
            ) {
                setshowsourceDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleDownload = (event) => {
        const value = event.target.value;

        if (value === "pdf") {
            downloadPDF();
        } else if (value === "word") {
            downloadWord();
        } else if (value === "excel") {
            downloadExcel();
        }
        setIsDropdownVisible(false);
    };

    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    // const toggleDropdown = () => {
    //     setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
    // };

    const downloadExcel = () => {
        const sortedLeads = [...potentialStatusDownload].sort(
            (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
        );

        const ws = XLSX.utils.json_to_sheet(
            sortedLeads.map((LeadReport, index) => ({
                "Sr. No": index + 1,
                "Lead Date": LeadReport.LeadDate
                    ? formatDateByCountry(LeadReport.LeadDate)
                    : " ",
                "Client Name": LeadReport.ClientName,
                "Project Name": LeadReport.ProjectName,
                "Lead Type": LeadReport.LeadType,
                "Quoted Value": USAComma(LeadReport.QuotedValue), // ✅ Ensure it's a number
                Source: LeadReport.Source,
                Status: LeadReport.Status,
                Group: LeadReport.AssignedGroup,
                "Follow-up Date":
                    LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                        ? " "
                        : formatDateByCountry(LeadReport.FollowupDate),
            }))
        );

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelBuffer], {
            bookType: "xlsx",
            type: "application/octet-stream",
        });
        saveAs(excelFile, "PotentialLeadReports.xlsx");
    };

    const downloadPDF = () => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [
                [
                    "Sr. No",
                    "Lead Date",
                    "Client Name",
                    "Project Name",
                    "Lead Type",
                    "Quoted Value",
                    "Source",
                    "Status",
                    "Group",
                    "Follow-up Date",
                ],
            ],
            body: potentialStatusDownload.map((LeadReport, index) => [
                index + 1,
                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " ",
                LeadReport.ClientName,
                LeadReport.ProjectName,
                LeadReport.LeadType,
                `${currency}${USAComma(LeadReport.QuotedValue)}`,
                LeadReport.Source,
                LeadReport.Status,
                LeadReport.AssignedGroup,
                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                    ? " "
                    : formatDateByCountry(LeadReport.FollowupDate),
            ]),
            styles: {
                fontSize: 7,
            },
            headStyles: {
                fontSize: 8,
            },
        });
        doc.save("PotentialLeadReports.pdf");
    };

    const downloadWord = () => {
        const safeText = (value) => (value === null || value === undefined ? " " : String(value));
        const docxParagraphFromText = (value) =>
            new Paragraph({
                children: [new TextRun(safeText(value))],
            });
        const leadRows = (potentialStatusDownload || []).filter((row) => row != null);
        const headerRow = new TableRow({
            children: [
                new TableCell({
                    children: [docxParagraphFromText("Sr.No")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Lead Date")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Client Name")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Project Name")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Lead Type")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Quoted Value")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Source")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Status")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Group")],
                }),
                new TableCell({
                    children: [docxParagraphFromText("Follow-up Date")],
                }),
            ],
        });

        const dataRows = leadRows.map((LeadReport, index) => {
            return new TableRow({
                children: [
                    new TableCell({
                        children: [docxParagraphFromText(`${index + 1}`)],
                    }),
                    new TableCell({
                        children: [
                            docxParagraphFromText(
                                LeadReport.LeadDate ? formatDateByCountry(LeadReport.LeadDate) : " "
                            ),
                        ],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.ClientName)],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.ProjectName)],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.LeadType)],
                    }),
                    new TableCell({
                        children: [
                            docxParagraphFromText(
                                `${currency}${USAComma(LeadReport.QuotedValue)}`
                            ),
                        ],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.Source)],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.Status)],
                    }),
                    new TableCell({
                        children: [docxParagraphFromText(LeadReport.AssignedGroup)],
                    }),
                    new TableCell({
                        children: [
                            docxParagraphFromText(
                                LeadReport.Status === "Won" || LeadReport.Status === "Lost"
                                    ? " "
                                    : formatDateByCountry(LeadReport.FollowupDate)
                            ),
                        ],
                    }),
                ],
            });
        });

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Table({
                            rows: [headerRow, ...dataRows],
                        }),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then((blob) => {
            saveAs(blob, "PotentialLeadReports.docx");
        });
    };

    const popupRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setIsDropdownVisible(false); // Close the popup if clicked outside
        }
    };
    useEffect(() => {
        if (isDropdownVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isDropdownVisible]);

    const [potentialStatus, setPotentialStatus] = useState([]);

    const aggregatePotentialStatusData = useCallback(
        (filteredData, totalDenominatorCount) => {
            if (!Array.isArray(filteredLeadReportsLead) || filteredLeadReportsLead.length === 0) {
                return;
            }

            // Calculate total amount and count for filtered data
            const totalFilteredAmount = filteredData.reduce(
                (sum, lead) => sum + (lead.QuotedValue || 0),
                0
            );
            console.log("filteredData1", filteredData)
            // Denominator = total leads (date-filtered, without status filter) so a selected status
            // is shown as selectedStatusCount / totalLeads instead of always 100%.
            const totalFilteredCount =
                (totalDenominatorCount ?? filteredData.length) || 1;
            const totalCauculatedCount = filteredData.length;

            // Group data by status
            const groupedData = filteredData.reduce((acc, lead) => {
                // const status = lead.Status;
                const status = lead.Status?.toLowerCase() || "";
                if (!acc[status]) {
                    acc[status] = [];
                }
                acc[status].push(lead);
                return acc;
            }, {});

            // Process each status group
            const statusData = Object.keys(groupedData).map((status) => {
                const leadsForStatus = groupedData[status];
                const totalQuotedAmount = leadsForStatus.reduce(
                    (sum, lead) => sum + (lead.QuotedValue || 0),
                    0
                );
                const count = leadsForStatus.length;
                // Always calculate percentage based on total unfiltered count
                const percentage = ((count / totalFilteredCount) * 100).toFixed(2);

                return {
                    status,
                    amount: totalQuotedAmount,
                    count,
                    percentage: parseFloat(percentage), // Convert to number for accurate summation
                };
            });
            // Calculate total percentage
            const totalPercentage = statusData
                .reduce((sum, status) => sum + status.percentage, 0)
                .toFixed(2);

            // Update state with aggregated data
            setPotentialStatus(statusData);
            setTotalStatusAmount(totalFilteredAmount);
            setTotalStatusCount(totalCauculatedCount);
            setTotalPercentage(totalPercentage); // Store total percentage in state
        },
        [filteredLeadReportsLead]
    );



    useEffect(() => {
        if (filteredReports) {
            aggregatePotentialStatusData(filteredReports);
            setPotentialStatusDownload(filteredReports);
        }
    }, [
        filteredReports,
        aggregatePotentialStatusData,
        filteredLeadReportsLead,
    ]);

    const [selectedTab, setSelectedTab] = useState("graph");
    const [statusFilterDateFrom, setStatusFilterDateFrom] = useState(null);
    const [statusFilterDateTo, setStatusFilterDateTo] = useState(null);
    const [statusFilter, setStatusFilter] = useState("All");
    const [potentialStatusfinal] = useState("All");
    const [totalStatusAmount, setTotalStatusAmount] = useState(0);
    const [totalstatusCount, setTotalStatusCount] = useState(0);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const navigate = useNavigate();

    const completePotentialStatus = useMemo(() => {
        if (!potentialStatus.length) return [];
        const statusOrder = ["Won", "Won Recurring", "Pending", "Lost"];
        const normalizedOrder = statusOrder.map((s) => s.toLowerCase());
        const orderedStatuses = statusOrder.map((status) => {
            const found = potentialStatus.find(
                (item) => String(item?.status || "").toLowerCase() === status.toLowerCase()
            );
            return (
                found || {
                    status,
                    amount: 0,
                    count: 0,
                    percentage: 0,
                }
            );
        });
        const extraStatuses = potentialStatus.filter(
            (item) => !normalizedOrder.includes(String(item?.status || "").toLowerCase())
        );
        return [...orderedStatuses, ...extraStatuses];
    }, [potentialStatus]);

    /** Pastel track (no glass) — Won / Recurring / Pending / Lost order */
    const barVerticalTrackAt = (idx) => {
        const presets = [
            "border border-green-200 bg-green-100",
            "border border-blue-200 bg-blue-100",
            "border border-orange-200 bg-orange-100",
            "border border-red-200 bg-red-100",
        ];
        return presets[Math.min(idx, presets.length - 1)];
    };

    /** Soft gradient fills (slightly darker for contrast) */
    const barVerticalFillAt = (idx) => {
        const presets = [
            "bg-gradient-to-t from-green-700 to-green-500",
            "bg-gradient-to-t from-blue-700 to-blue-500",
            "bg-gradient-to-t from-orange-700 to-orange-500",
            "bg-gradient-to-t from-rose-600 to-rose-400",
        ];
        return presets[Math.min(idx, presets.length - 1)];
    };

    /** Y-axis tick labels only — matches 25% grid steps (no logic coupling) */
    const Y_AXIS_TICKS_FIVE = [100, 75, 50, 25, 0];

    console.log("potentialStatusDownload", totalstatusCount)

    const handleFromDateChange = (date) => {
        if (!date) return;
        setStatusFilterDateFrom(date);
        dispatch(setPotentialFromDateRedux(date));
    };
    const handleToDateChange = (date) => {
        if (!date) return;
        setStatusFilterDateTo(date);
        dispatch(setPotentialToDateRedux(date))
    };
    const handleStatusChange = (status) => {
        setStatusFilter(status);
        setshowsourceDropdown(false); // Close dropdown after selection
        dispatch(setPotentialStatusRedux(status))
    };


    const [statuses, setStatuses] = useState([]);

    const { status } = useSelector((state) => state.status);
    const statusFilterDateFromRedux = useSelector((state) => state.filters.statusFilterDateFrom);
    const statusFilterDateToRedux = useSelector((state) => state.filters.statusFilterToFrom);
    const statusPotentialRedux = useSelector((state) => state.filters.statusFilter);

    useEffect(() => {
        if (statusFilterDateFromRedux !== undefined && statusFilterDateFromRedux !== null) {
            setStatusFilterDateFrom(statusFilterDateFromRedux);
        } else {
            setStatusFilterDateFrom(null);
        }
    }, [statusFilterDateFromRedux]);


    useEffect(() => {
        if (statusFilterDateToRedux !== undefined && statusFilterDateToRedux !== null) {
            setStatusFilterDateTo(statusFilterDateToRedux)
        } else {
            setStatusFilterDateTo("")
        }
    }, [statusFilterDateToRedux])

    useEffect(() => {
        if (statusPotentialRedux !== undefined && statusPotentialRedux !== null) {
            setStatusFilter(statusPotentialRedux)
        } else {
            setStatusFilter("All")
        }
    }, [statusPotentialRedux])

    useEffect(() => {
        dispatch(fetchStatus());
    }, [dispatch]);

    useEffect(() => {
        if (status.length > 0) {
            setStatuses(status);
        }
    }, [status]);

    const sortedStatuses = [...statuses].sort((a, b) => {
        // Spread operator to create a new array
        const order = ["Won", "Won Recurring", "Pending", "Lost"];
        const indexA = order.indexOf(a.status);
        const indexB = order.indexOf(b.status);

        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
    });

    const handlePotentialStatusFilter = () => {
        const normalize = (value) => String(value ?? "").trim().toLowerCase();
        const selectedStatus = normalize(statusFilter);
        // Date-filtered (without status) — used as the denominator for percentage
        const dateFilteredData = filteredLeadReportsLead.filter((item) => {
            const itemDate = new Date(item.LeadDate);
            return (
                (!statusFilterDateFrom || itemDate >= statusFilterDateFrom) &&
                (!statusFilterDateTo || itemDate <= statusFilterDateTo)
            );
        });
        // Filter data based on date range and status selection
        const filteredData = dateFilteredData.filter((item) => {
            const isMatchingStatus =
                !selectedStatus ||
                selectedStatus === "all" ||
                normalize(item.Status) === selectedStatus;
            return isMatchingStatus;
        });
        // Update state or pass filtered data for further processing
        aggregatePotentialStatusData(filteredData, dateFilteredData.length);
        setPotentialStatusDownload(filteredData);
    };


    const potentialNavigationl1 = useCallback(
        (clickedStatus) => {
            console.log("filteredDataLeadSourcel1 clickedStatus", clickedStatus)
            const filteredDatapotentiall1 = potentialStatusDownload.filter(
                (item) => item.Status?.toLowerCase() === clickedStatus?.toLowerCase()
            );
            console.log("filteredDataLeadSourcel1 ", filteredDatapotentiall1)

            dispatch(setFilteredNavData(filteredDatapotentiall1));

            navigate(`/dashboard/lead-report`);
        },
        [potentialStatusDownload, navigate, dispatch]
    );

    const getBarDisplayPct = (item) => {
        const match =
            potentialStatusfinal === "All" || item.status === potentialStatusfinal;
        const pct = match ? Number(item.percentage) || 0 : 0;
        return `${fmtPctDisplay(pct)}%`;
    };

    const getBarFillPercent = (item) => {
        const match =
            potentialStatusfinal === "All" || item.status === potentialStatusfinal;
        return match ? Number(item.percentage) || 0 : 0;
    };

    return (
        <div
            className="flex h-full min-h-0 w-full justify-center bg-transparent"
        >
            <div className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
                <div className="shrink-0 border-b border-gray-200 pb-2">
                    <div className="flex flex-nowrap items-center justify-between gap-2 overflow-visible">
                        <div className="flex min-w-0 flex-nowrap items-center gap-3">
                            <button
                                type="button"
                                onClick={() => handleToggleTable()}
                                className="flex items-center justify-center rounded-lg border border-gray-200 bg-white p-1.5 transition hover:bg-gray-50"
                                aria-label={showgraph ? "Collapse" : "Expand"}
                            >
                                <ChevronDown className={`h-5 w-5 cursor-pointer text-gray-600 ${showgraph ? "" : "rotate-180"}`} />
                            </button>

                            {selectedTab === "table" && (
                                <button
                                    type="button"
                                    title="Graph"
                                    className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                    onClick={() => setSelectedTab("graph")}
                                >
                                    <ChartColumnDecreasing className="h-5 w-5" strokeWidth={2} aria-hidden />
                                </button>
                            )}
                            {selectedTab === "graph" && (
                                <button
                                    type="button"
                                    title="Table"
                                    className="flex shrink-0 items-center justify-center rounded-full bg-blue-600 p-1 text-white transition hover:bg-blue-700"
                                    onClick={() => setSelectedTab("table")}
                                >
                                    <TableOfContents className="h-5 w-5 rotate-180" strokeWidth={2} aria-hidden />
                                </button>
                            )}

                            <div className="flex min-w-0 items-center gap-2">
                                <h1 className="dashboard-card-title min-w-0 truncate">
                                    POTENTIAL STATUS
                                </h1>
                            </div>
                        </div>

                        <div className="flex shrink-0 items-center gap-2">
                            <div className="show-potential-download text-2xl sm:text-3xl md:text-2xl">
                                <div className="relative inline-block">
                                    <div
                                        ref={popupRef}
                                        className="flex items-center"
                                    >
                                        <span onClick={() => sendDownlodTile()}>
                                            <DownloadReport tableLeadReports={potentialStatusDownload} />
                                        </span>
                                        {isDropdownVisible && (
                                            <div className="absolute top-full z-50 -left-8 overflow-hidden rounded-lg border border-gray-200 bg-white text-base shadow-lg">
                                                <div
                                                    className="cursor-pointer px-3 py-2 transition hover:bg-gray-50"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "pdf" } })
                                                    }
                                                >
                                                    PDF
                                                </div>
                                                <div
                                                    className="cursor-pointer px-3 py-2 transition hover:bg-gray-50"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "excel" } })
                                                    }
                                                >
                                                    Excel
                                                </div>
                                                <div
                                                    className="cursor-pointer px-3 py-2 transition hover:bg-gray-50"
                                                    onClick={() =>
                                                        handleDownload({ target: { value: "word" } })
                                                    }
                                                >
                                                    Word
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showgraph && canShowGraphs && (
                    <div className="flex min-h-0 flex-1 flex-col space-y-2 overflow-hidden pt-2">
                        {canShowFilter && (
                            <div className="shrink-0 border-b border-gray-200 pb-3">
                                <div className="flex min-w-0 flex-col gap-1.5">
                                    <div className="flex w-full min-w-0 flex-wrap items-start gap-3 text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                                        <div className="min-w-0 flex-1 basis-[7rem] text-left pl-1">From</div>
                                        <div className="min-w-0 flex-1 basis-[7rem] text-left pl-4">To</div>
                                        <div className="w-36 shrink-0 sm:w-40 text-left pl-2">Status</div>
                                        {/* Spacer to align with the Apply button column */}
                                        <div className="w-[6.5rem] shrink-0" aria-hidden />
                                    </div>
                                    <div className="flex min-w-0 flex-wrap items-center gap-3">
                                        <div className="flex h-10 min-w-0 flex-1 basis-[7rem] items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 text-sm">
                                            <Calendar className="h-4 w-4 shrink-0 text-gray-700" strokeWidth={2} />
                                            <div className="min-h-0 min-w-0 flex-1">
                                                <DatePicker
                                                    selected={statusFilterDateFrom}
                                                    onChange={handleFromDateChange}
                                                    dateFormat={getDateFormat()}
                                                    className="h-10 w-full border-0 bg-transparent text-sm text-gray-800 outline-none ring-0 date-picker-placeholder"
                                                    placeholderText={getDatePlaceholder()}
                                                    maxDate={new Date()}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="flex h-10 min-w-0 flex-1 basis-[7rem] items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 text-sm">
                                            <Calendar className="h-4 w-4 shrink-0 text-gray-700" strokeWidth={2} />
                                            <div className="min-h-0 min-w-0 flex-1">
                                                <DatePicker
                                                    selected={statusFilterDateTo}
                                                    onChange={handleToDateChange}
                                                    dateFormat={getDateFormat()}
                                                    className="h-10 w-full border-0 bg-transparent text-sm text-gray-800 outline-none ring-0 date-picker-placeholder"
                                                    placeholderText={getDatePlaceholder()}
                                                    required
                                                    minDate={
                                                        statusFilterDateFrom
                                                            ? new Date(
                                                                  statusFilterDateFrom.getTime() + 86400000
                                                              )
                                                            : null
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div
                                            ref={StatusdropdownRef}
                                            className="relative w-36 min-w-0 shrink-0 sm:w-40"
                                        >
                                            <div className="relative flex h-10 w-full items-center rounded-lg border border-gray-300 bg-white">
                                                <button
                                                    type="button"
                                                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                                                    className="flex h-10 w-full min-w-0 items-center justify-between gap-1 truncate px-3 pr-9 text-left text-sm text-gray-800 focus:outline-none"
                                                >
                                                    <span className="truncate">{statusFilter}</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="absolute right-2 top-1/2 z-20 -translate-y-1/2 p-0.5 text-gray-700"
                                                    onClick={() => setshowsourceDropdown(!showsourseDropdown)}
                                                    aria-label="Toggle status"
                                                >
                                                    <ExpandMoreIcon className="!text-gray-700" fontSize="small" />
                                                </button>
                                                {showsourseDropdown && (
                                                    <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-48 min-w-[7rem] overflow-y-auto rounded-lg border border-black/20 bg-white py-1 text-sm shadow-lg">
                                                        <button
                                                            type="button"
                                                            className="block w-full px-3 py-1.5 text-left text-sm transition hover:bg-gray-100"
                                                            onClick={() => handleStatusChange("All")}
                                                        >
                                                            All
                                                        </button>
                                                        {sortedStatuses.map((statuse) => (
                                                            <button
                                                                type="button"
                                                                key={statuse.id}
                                                                className="block w-full px-3 py-1.5 text-left text-sm transition hover:bg-gray-100"
                                                                onClick={() => handleStatusChange(statuse.status)}
                                                            >
                                                                {statuse.status}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="h-10 shrink-0 whitespace-nowrap rounded-md border-2 border-gray-700 bg-white px-5 text-xs font-semibold text-[#1F2937] tracking-widest"
                                            onClick={handlePotentialStatusFilter}
                                        >
                                            SUBMIT
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="flex min-h-0 flex-1 flex-col space-y-2 overflow-hidden px-0 pb-1 pt-0">
                            {selectedTab === "graph" && potentialStatus.length > 0 && (
                                <>
                                    <div className="relative z-0 min-h-0 w-full min-w-0 pt-0">
                                        <div className="relative h-64 w-full min-w-0 pl-10">
                                            {/* Percentage row (aligned with bar columns) */}
                                            <div className="absolute left-10 right-2 top-0 z-20 flex h-6 justify-around gap-1">
                                                {completePotentialStatus.map((item, idx) => {
                                                    const disp = getBarDisplayPct(item);
                                                    return (
                                                        <span
                                                            key={`pct-${item.status}-${idx}`}
                                                            className="min-w-0 flex-1 text-center text-sm font-semibold tabular-nums text-black"
                                                        >
                                                            {disp}
                                                        </span>
                                                    );
                                                })}
                                            </div>

                                            {/* Y-axis: 100% → 0% in 25% steps */}
                                            <div className="absolute left-0 top-10 bottom-6 z-10 flex w-9 flex-col justify-between text-xs font-medium text-gray-400">
                                                {Y_AXIS_TICKS_FIVE.map((v) => (
                                                    <span key={v} className="leading-none tabular-nums">
                                                        {v}%
                                                    </span>
                                                ))}
                                            </div>

                                            {/* Faint grid: lines at 100%, 75%, 50%, 25% (value scale from bottom) */}
                                            <div className="pointer-events-none absolute left-10 right-0 top-10 bottom-6 z-0">
                                                <div className="relative h-full w-full">
                                                    <div className="absolute inset-x-0 top-0 border-t border-gray-200/40" />
                                                    <div className="absolute inset-x-0 top-[25%] border-t border-gray-200/40" />
                                                    <div className="absolute inset-x-0 top-[50%] border-t border-gray-200/40" />
                                                    <div className="absolute inset-x-0 top-[75%] border-t border-gray-200/40" />
                                                </div>
                                            </div>

                                            {/* Bars — track height matches plot (aligns with grid) */}
                                            <div className="absolute left-10 right-0 top-10 bottom-6 z-[2] flex justify-around gap-1 px-1">
                                                {completePotentialStatus.map((item, idx) => {
                                                    const fill = getBarFillPercent(item);
                                                    const pctW = Math.min(Number(fill) || 0, 100);
                                                    const fillGrad = barVerticalFillAt(idx);
                                                    const trackClass = barVerticalTrackAt(idx);
                                                    const roundTop = pctW >= 12;
                                                    return (
                                                        <button
                                                            key={`${item.status}-${idx}`}
                                                            type="button"
                                                            className="flex h-full min-w-0 max-w-[6rem] flex-1 flex-col justify-end focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500/30"
                                                            onClick={() => potentialNavigationl1(item.status)}
                                                        >
                                                            <div
                                                                className={`mx-auto flex h-full w-12 max-w-full flex-col justify-end overflow-hidden rounded-2xl sm:w-14 ${trackClass}`}
                                                            >
                                                                {pctW > 0 && (
                                                                    <div
                                                                        className={`w-full shrink-0 ${fillGrad} transition-all duration-500 ease-out ${roundTop ? "rounded-2xl" : "rounded-b-2xl"}`}
                                                                        style={{
                                                                            height: `${pctW}%`,
                                                                            minHeight:
                                                                                pctW > 0 && pctW < 1
                                                                                    ? "3px"
                                                                                    : undefined,
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </button>
                                                    );
                                                })}
                                            </div>

                                            {/* Baseline at 0% — slightly darker than grid */}
                                            <div className="pointer-events-none absolute bottom-6 left-10 right-0 z-[3] border-t border-gray-400" />

                                            {/* Category labels */}
                                            <div className="absolute bottom-0 left-10 right-2 flex h-6 items-start justify-around gap-1">
                                                {completePotentialStatus.map((item, idx) => {
                                                    const label = item.status
                                                        .toLowerCase()
                                                        .replace(/\b\w/g, (c) => c.toUpperCase());
                                                    return (
                                                        <span
                                                            key={`lbl-${item.status}-${idx}`}
                                                            className="min-w-0 flex-1 text-center text-[10px] font-medium leading-tight text-gray-600 sm:text-xs"
                                                        >
                                                            {label}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {selectedTab === "table" ? (
                                potentialStatus.length > 0 ? (
                                    <div className="w-full min-h-0 flex-1 rounded-lg border border-gray-200 bg-white p-2">
                                        <div className="max-h-[18rem] overflow-auto">
                                            <table className="w-full divide-y divide-gray-200 border border-gray-200 text-gray-800">
                                                <thead className="sticky top-0 z-10 bg-gray-50 text-xs font-semibold uppercase tracking-wide text-gray-600">
                                                    <tr>
                                                        <th className="border-b border-gray-200 px-3 py-2 text-left">
                                                            Status
                                                        </th>
                                                        <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                            Count
                                                        </th>
                                                        <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                            %
                                                        </th>
                                                        <th className="border-b border-gray-200 px-3 py-2 text-center">
                                                            Amount({currency})
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white text-xs">
                                                    {potentialStatus
                                                        .sort((a, b) => {
                                                            const statusOrder = [
                                                                "WON",
                                                                "WON RECURRING",
                                                                "PENDING",
                                                                "LOST",
                                                            ];
                                                            return (
                                                                statusOrder.indexOf(a.status.toUpperCase()) -
                                                                statusOrder.indexOf(b.status.toUpperCase())
                                                            );
                                                        })
                                                        .map((item, index) => (
                                                            <tr key={index}>
                                                                <td
                                                                    onClick={() =>
                                                                        potentialNavigationl1(item.status)
                                                                    }
                                                                    style={{ cursor: "pointer" }}
                                                                    className="border-b border-gray-200/40 px-3 py-1 text-left"
                                                                >
                                                                    {item.status.toUpperCase()}
                                                                </td>
                                                                <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                                    {item.count}
                                                                </td>
                                                                <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                                    {item.percentage}
                                                                </td>
                                                                <td className="border-b border-gray-200/40 px-3 py-1 text-center">
                                                                    {USAComma(item.amount)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    <tr className="border-t border-gray-200 bg-gray-50 text-xs font-semibold">
                                                        <td className="px-3 py-2 text-left">TOTAL :</td>
                                                        <td className="px-3 py-2 text-center">
                                                            {totalstatusCount}
                                                        </td>
                                                        <td className="px-3 py-2 text-center">
                                                            {totalPercentage === "99.99"
                                                                ? 100
                                                                : totalPercentage}
                                                        </td>
                                                        <td className="px-3 py-2 text-center">
                                                            {USAComma(totalStatusAmount)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex w-full flex-1 items-center justify-center text-center">
                                        <p className="noDataAvailable">No data available</p>
                                    </div>
                                )
                            ) : potentialStatus.length > 0 ? null : (
                                <div className="flex w-full flex-1 items-center justify-center text-center">
                                    <p className="noDataAvailable">No data available</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PotentialStatus